import { render, staticRenderFns } from "./ProductInventoryAvailable.vue?vue&type=template&id=07953cd7&"
import script from "./ProductInventoryAvailable.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryAvailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports